import { render, staticRenderFns } from "./RotationTransfers.html?vue&type=template&id=7700cb57&external"
import script from "./RotationTransfers.js?vue&type=script&lang=js&external"
export * from "./RotationTransfers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports